import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { DocumentPage } from '../../../features/documents/ui/document-panel.tsx';

// Без проверки прав в адресе: документ сделки открывают её участники, свои договор и акты — сотрудник, пакет — его
// подписант, всё без хранилища целиком. Доступ проверяет сервер, чужой документ — «нет доступа» на странице.
export const Route = createFileRoute('/_app/documents/$id')({
  component: DocumentRoute,
});

/** Документ на всю страницу (⌘↵ из панели). */
function DocumentRoute() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  return (
    <DocumentPage
      id={id}
      onBack={() => {
        void navigate({ to: '/documents', search: { doc: id } });
      }}
      onOpenDocument={(next) => {
        void navigate({ to: '/documents/$id', params: { id: next } });
      }}
    />
  );
}
